import React from 'react';
import { useComponentVisible } from '../_hooks';
import './DropdownMenu.css';
var DropdownMenu = function (props) {
    var iconClass = props.iconClass, customClass = props.customClass, children = props.children, className = props.className;
    var _a = useComponentVisible(false), parentRef = _a.parentRef, toggleRef = _a.toggleRef, isVisible = _a.isVisible;
    return (React.createElement("div", { ref: parentRef, className: "dropdown b-dropdown btn-group" + (customClass ? " " + customClass : '') + (className ? " " + className : '') },
        React.createElement("button", { ref: toggleRef, "aria-haspopup": "true", "aria-expanded": isVisible, type: "button", className: "btn dropdown-toggle btn-none dropdown-toggle-no-caret" },
            React.createElement("i", { className: iconClass })),
        isVisible && (React.createElement("ul", { role: "menu", tabIndex: -1, className: "dropdown-menu py-3 dropdown-menu-right show" }, children))));
};
export default DropdownMenu;
